import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { DJCEService } from '../../services/api';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';

//Componentes
import DJCEEnEsperaDeFirma from './DJCEEnEsperaDeFirma';
import Spinner from '../spinner/Spinner';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';

function DJCEEnEsperaDeFirmaContainer() {
    const { token, masters } = useGlobalContext();

    const FormMethods = useForm();

    const [loader, setLoader] = useState(false);
    const [DJCEVerificada, setDJCEVerificada] = useState(false);
    const [tableData, setTableData] = useState(buildTableData());
    const [DJCEsForSignList, setDJCEsForSignList] = useState([]);

    useEffect(() => {
        const fetchDJCEs = async () => {
            try {
                setLoader(true);
                const DJCEsForSign = await DJCEService.allForINAVISigning({
                    token,
                    // serie: parseInt(dayjs(new Date()).format('YYYY')),
                });
                if (DJCEsForSign) {
                    setDJCEsForSignList(DJCEsForSign.data);
                    setTableData(buildTableData(DJCEsForSign.data));
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
            }
        };
        fetchDJCEs();
    }, [DJCEVerificada]);

    // useEffect(() => {
    //     DJCEsForSignList.forEach((DJCE, i) => {
    //         FormMethods.setValue(
    //             `djce_para_aprobar[${i}]`,
    //             FormMethods.watch('all_djce_para_aprobar')
    //         );
    //     });
    // }, [FormMethods.watch('all_djce_para_aprobar')]);

    function buildTableData(data = []) {
        return {
            headers: [
                // <input
                //     type="checkbox"
                //     {...FormMethods.register(`all_djce_para_aprobar`)}
                // />,
                ' ',
                'ID',
                'Viñedo',
                'Titulares',
                'Cerrada',
                ' ',
            ],
            pagination: 10,
            data:
                data.length > 0
                    ? data?.map((dj, i) => {
                          return {
                              check: (
                                  <input
                                      type="checkbox"
                                      {...FormMethods.register(
                                          `djce_para_aprobar[${i}]`
                                      )}
                                      value={dj.id}
                                  />
                              ),
                              id: `${dj.serie}-P-${dj.numero}`,
                              viniedo: dj.viniedo,
                              titulares: dj.titulares,
                              cerrada: !dj.fecha_Cierre
                                  ? 'NO'
                                  : dayjs(dj.fecha_Cierre).format('DD-MM-YYYY'),
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaEfectiva + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>

                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .nuevaCosechaEfectiva + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={pencil}
                                              title="Editar"
                                              alt="Editar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    }

    async function onSubmitVistaDJCEs(data) {
        data.djce_para_aprobar = data.djce_para_aprobar
            .filter((id) => typeof id !== 'boolean')
            .map((id) => {
                return parseInt(id);
            });
        // console.log(data);
        try {
            setLoader(true);

            const DJCEsVerificadas = await DJCEService.verificarDJCEs({
                token,
                id: data.djce_para_aprobar,
            });

            if (DJCEsVerificadas) {
                toast('DJCEs verificadas con éxito', { type: 'success' });
                setDJCEVerificada(!DJCEVerificada);
                FormMethods.reset();
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    }

    return loader ? (
        <Spinner />
    ) : (
        <DJCEEnEsperaDeFirma
            states={{ tableData }}
            functions={{ ...FormMethods, onSubmitVistaDJCEs }}
        />
    );
}

export default DJCEEnEsperaDeFirmaContainer;
